<template>
  <div
    v-if="programArticle"
    class="
      shadow-md
      bg-white
      rounded-[20px]
      relative
    "
    :class="[isWorkshop ? 'max-h-[275px]' : 'max-h-[260px]', {'ring-2 ring-brand-blue': selected === programArticle.hall}]"
  >
    <div class="grid" style="grid-template-columns: auto minmax(0, 1fr);">
        <img
          v-if="programArticle.speaker.photo_url"
          class="object-cover rounded-l-[20px]"
          :class="[isWorkshop ? 'w-[160px]' : 'w-[175px]', isWorkshop ? 'h-[275px]' : 'h-[260px]']"
          :src="programArticle.speaker.photo_url"
          :alt="'Profilová fotografie: ' + programArticle.speaker.name"
        />

        <svg
          v-else
          class="w-[72px] h-[72px] mr-4 text-brand-blue"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
            clip-rule="evenodd"
          ></path>
        </svg>
      <div class="flex flex-col p-[30px]">
        <div class="flex flex-col">
          <div class="flex flex-row justify-between">
            <p class="font-semibold text-[20px]"
               :class="[highlightColor === 'blue' ? 'text-[#2699C6]' : 'text-brand-orange']">
              {{ talkTime() }}
            </p>
            <div :class="{'hidden' : isWorkshop}" class="flex flex-row gap-[24px]">
              <!-- socky -->
              <a
                class="transition-all duration-200 group hover:opacity-90"
                v-if="programArticle.speaker.web"
                :href="programArticle.speaker.web"
                target="_blank"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  <path
                    d="M17.6016 2.41602C16.3192 2.41602 15.115 2.91587 14.2078 3.82227L12.6078 5.42227C11.7014 6.32947 11.2016 7.53362 11.2016 8.81602C11.2016 9.82743 11.5163 10.7872 12.0922 11.5941L10.7797 12.9066C9.97265 12.331 9.01237 12.016 8.00156 12.016C6.71916 12.016 5.51501 12.5159 4.60781 13.4223L3.00781 15.0223C2.10141 15.9295 1.60156 17.1336 1.60156 18.416C1.60156 19.6984 2.10141 20.9026 3.00781 21.8098C3.91421 22.717 5.11916 23.216 6.40156 23.216C7.68396 23.216 8.88811 22.7162 9.79531 21.8098L11.3953 20.2098C12.3017 19.3026 12.8016 18.0984 12.8016 16.816C12.8016 16.3752 12.7386 15.9452 12.625 15.5316L11.1859 16.9707C11.1491 17.7379 10.8481 18.4937 10.2641 19.0785L8.66406 20.6785C7.41606 21.9265 5.38626 21.9265 4.13906 20.6785C2.89186 19.4305 2.89106 17.4007 4.13906 16.1535L5.73906 14.5535C6.36306 13.9295 7.18313 13.6191 8.00312 13.6191C8.56454 13.6191 9.12048 13.7753 9.61875 14.0676L7.43594 16.2504C7.35916 16.3241 7.29786 16.4124 7.25563 16.5101C7.2134 16.6078 7.19109 16.713 7.19001 16.8194C7.18893 16.9258 7.20909 17.0314 7.24932 17.1299C7.28956 17.2285 7.34904 17.318 7.42431 17.3933C7.49957 17.4685 7.5891 17.528 7.68764 17.5683C7.78618 17.6085 7.89176 17.6286 7.99819 17.6276C8.10462 17.6265 8.20977 17.6042 8.30747 17.5619C8.40518 17.5197 8.49347 17.4584 8.56719 17.3816L16.5672 9.38164C16.6828 9.26927 16.7617 9.1246 16.7937 8.96658C16.8257 8.80857 16.8092 8.64458 16.7463 8.49611C16.6835 8.34764 16.5773 8.22162 16.4416 8.13455C16.3059 8.04749 16.1471 8.00345 15.9859 8.0082C15.7781 8.0144 15.5808 8.10126 15.4359 8.25039L13.2531 10.4332C12.5322 9.20671 12.6873 7.60459 13.7391 6.55352L15.3391 4.95352C15.9631 4.32952 16.7816 4.01914 17.6016 4.01914C18.4216 4.01914 19.2401 4.33032 19.8641 4.95352C21.1121 6.20152 21.1121 8.23132 19.8641 9.47852L18.2641 11.0785C17.6801 11.6625 16.9234 11.9636 16.1562 12.0004L14.7172 13.4395C15.1308 13.5531 15.5608 13.616 16.0016 13.616C17.284 13.616 18.4881 13.1162 19.3953 12.2098L20.9953 10.6098C21.9017 9.70257 22.4016 8.49842 22.4016 7.21602C22.4016 5.93362 21.9017 4.72947 20.9953 3.82227C20.0881 2.91587 18.884 2.41602 17.6016 2.41602Z"
                    :fill="highlightColor === 'blue' ? '#2699C6' : '#f6a02c'"/>
                </svg>
              </a>
              <a
                class="transition-all duration-200 group hover:opacity-90"
                v-if="programArticle.speaker.linkedin"
                :href="programArticle.speaker.linkedin"
                target="_blank"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M20.0387 20.6169H16.1122V13.7464C16.1122 11.8617 15.2808 10.8102 13.7897 10.8102C12.1671 10.8102 11.2041 11.9059 11.2041 13.7464V20.6169H7.27762V7.85574H11.2041V9.29079C11.2041 9.29079 12.436 7.12911 15.2121 7.12911C17.9891 7.12911 20.0387 8.82373 20.0387 12.3301V20.6169ZM2.80338 5.81485C1.47917 5.81485 0.40625 4.73316 0.40625 3.39913C0.40625 2.06609 1.47917 0.984375 2.80338 0.984375C4.12661 0.984375 5.19952 2.06609 5.19952 3.39913C5.2005 4.73316 4.12661 5.81485 2.80338 5.81485ZM0.40625 20.6169H5.31437V7.85574H0.40625V20.6169Z" :fill="highlightColor === 'blue' ? '#2699C6' : '#f6a02c'"/>
                </svg>
              </a>
              <a
                class="transition-all duration-200 group hover:opacity-90"
                v-if="programArticle.speaker.twitter"
                :href="programArticle.speaker.twitter"
                target="_blank"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  <path
                    d="M16.0002 3.81641C13.2845 3.81641 11.0805 6.01077 11.0216 8.71289C8.62052 8.42491 7.05695 7.52716 6.09782 6.64258C5.03415 5.66159 4.69743 4.79004 4.69743 4.79004C4.64827 4.66618 4.567 4.55765 4.46198 4.47562C4.35696 4.39358 4.23198 4.34101 4.0999 4.32331C3.96782 4.3056 3.83341 4.32341 3.71049 4.37489C3.58757 4.42637 3.48059 4.50967 3.40055 4.61621C3.40055 4.61621 2.50016 5.81641 2.50016 7.56641C2.50016 8.5669 2.81606 9.30718 3.19254 9.93457C3.17867 9.92808 3.08512 9.89551 3.08512 9.89551C2.96559 9.83583 2.83228 9.80915 2.69898 9.81825C2.56569 9.82735 2.43724 9.87189 2.32693 9.94726C2.21661 10.0226 2.12842 10.1261 2.07149 10.247C2.01456 10.3678 1.99095 10.5017 2.00309 10.6348C2.00309 10.6348 2.29176 12.7448 4.27555 14.2871L4.06852 14.3389C3.95614 14.3669 3.85178 14.4206 3.76363 14.4958C3.67548 14.5709 3.60592 14.6654 3.56042 14.772C3.51492 14.8785 3.4947 14.9941 3.50136 15.1097C3.50802 15.2254 3.54137 15.3379 3.59879 15.4385C3.59879 15.4385 3.93519 16.0075 4.63981 16.6064C5.05759 16.9616 5.6713 17.328 6.39469 17.667C5.5063 17.9916 4.18157 18.3164 2.25016 18.3164C2.10604 18.3164 1.96496 18.3579 1.84381 18.436C1.72266 18.514 1.62656 18.6253 1.56701 18.7566C1.50747 18.8878 1.48699 19.0335 1.50804 19.176C1.52909 19.3186 1.59077 19.4521 1.68571 19.5605C1.68571 19.5605 2.25882 20.1919 3.39176 20.7412C4.5247 21.2905 6.2699 21.8164 8.75016 21.8164C13.11 21.8164 16.2425 19.725 18.1974 17.0742C20.1524 14.4235 21.0002 11.247 21.0002 8.81641C21.0002 8.66218 20.9905 8.51013 20.9767 8.35938C22.0323 7.34221 22.4285 6.57752 22.4474 6.54004C22.5424 6.34954 22.507 6.12075 22.3595 5.96875C22.2125 5.81625 21.9847 5.7733 21.7912 5.8623L21.7101 5.89941C21.6406 5.93141 21.5711 5.96362 21.5011 5.99512C21.7046 5.67062 21.8652 5.32384 21.9767 4.96484C22.0387 4.76684 21.9718 4.54988 21.8078 4.42188C21.6438 4.29387 21.4179 4.28017 21.2404 4.38867C20.6293 4.76009 20.0435 5.0201 19.4338 5.19434C18.5364 4.34314 17.3286 3.81641 16.0002 3.81641ZM16.0002 5.31641C17.9417 5.31641 19.5002 6.87482 19.5002 8.81641C19.5002 10.8859 18.723 13.8344 16.9904 16.1836C15.2578 18.5328 12.6403 20.3164 8.75016 20.3164C6.86756 20.3164 5.61525 19.9759 4.67692 19.6074C5.65983 19.4548 6.50613 19.2511 7.11442 19.0156C8.16925 18.6073 8.73844 18.1357 8.73844 18.1357C8.84285 18.0461 8.92059 17.9295 8.96317 17.7987C9.00576 17.6679 9.01154 17.5279 8.97988 17.394C8.94822 17.2601 8.88034 17.1375 8.78368 17.0396C8.68701 16.9417 8.56528 16.8722 8.4318 16.8389C7.07044 16.4985 6.19732 15.9481 5.64957 15.4893L6.4318 15.2939C6.58649 15.2553 6.72486 15.1684 6.82682 15.0459C6.92879 14.9233 6.98904 14.7714 6.99883 14.6123C7.00863 14.4531 6.96746 14.295 6.8813 14.1609C6.79515 14.0267 6.66848 13.9235 6.51969 13.8662C4.89713 13.2421 4.21577 12.3596 3.86735 11.6201C4.29134 11.7079 4.68611 11.8164 5.25016 11.8164C5.41906 11.8163 5.58298 11.7591 5.71536 11.6542C5.84775 11.5493 5.94086 11.4028 5.97961 11.2384C6.01837 11.074 6.0005 10.9014 5.92891 10.7484C5.85731 10.5954 5.73618 10.4711 5.58512 10.3955C5.58512 10.3955 4.00016 9.66641 4.00016 7.56641C4.00016 7.18938 4.10458 6.95058 4.18082 6.66504C4.44241 7.01658 4.658 7.3557 5.08024 7.74512C6.36757 8.93238 8.49534 10.143 11.7101 10.3154C11.8118 10.3209 11.9136 10.3055 12.0092 10.2703C12.1048 10.2351 12.1922 10.1808 12.2662 10.1107C12.3401 10.0407 12.3989 9.95625 12.4392 9.86266C12.4794 9.76907 12.5002 9.66827 12.5002 9.56641V8.81641C12.5002 6.87482 14.0586 5.31641 16.0002 5.31641Z"
                    :fill="highlightColor === 'blue' ? '#2699C6' : '#f6a02c'"/>
                </svg>
              </a>
            </div>
          </div>
          <p
            class="
                font-semibold
                truncate
                text-brand-gray-900
                text-[16px]
              "
          >
            {{ programArticle.speaker.name }}
          </p>
          <p class="text-brand-gray-500 truncate"
             :class="[isWorkshop ? 'text-[14px]' : 'text-[16px]']"
          >
            {{ programArticle.speaker.position }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="mt-4 font-semibold truncate text-brand-gray-900 text-[18px]">
            {{ programArticle.title }}
          </p>

          <div class=" font-medium text-[16px] text-brand-gray-500"
               :class="[compact ? ' -mt-2 md:h-[12px]' : 'mt-2 md:h-[72px]']">
            {{ truncatedDescription }}

            <button
              v-if="hasTextOverflow && enableMoreInfo"
              @click.prevent="action"
              class="
          inline-block
          font-medium
          transition-all
          duration-200
          hover:opacity-80
          text-brand-blue text-body
        "
            >
              Více informací
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!isWorkshop && userLoggedIn && programVotingOpened && !hasHappeningSiblingUp"
      class="mt-2"
    >
      <RadioButton
        @clicked="removeTimeSlot"
        :name="'timeslot-' + programArticle.timeslot.index"
        :radioValue="programArticle.hall"
        :radioId="programArticle.id.toString()"
        label="To chci vidět"
        v-model="selected"
      />
    </div>
    <div
      v-if="isWorkshop && userLoggedIn && workshopRegistrationOpened"
      class="mt-7"
    >
      <div class="md:grid grid-cols-12">
        <div class="col-span-8">

          <button
            v-if="userAlreadyRegisteredToWorkshop"
            @click="unRegisterWorkshop"
            class="
            flex
            hover:opacity-80
            focus:outline-none
            transition-all
            duration-200
            items-center
            text-brand-orange
          "
          >
            <svg
              class="mr-1"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2C10.2458 2 8.7852 3.31072 8.54004 5H5.11914C5.07656 4.99271 5.03343 4.98912 4.99024 4.98926C4.95291 4.99006 4.9157 4.99365 4.87891 5H3.25C3.15062 4.99859 3.05194 5.01696 2.95972 5.05402C2.86749 5.09108 2.78355 5.1461 2.71277 5.21588C2.642 5.28566 2.58579 5.36882 2.54743 5.46051C2.50907 5.5522 2.48932 5.65061 2.48932 5.75C2.48932 5.84939 2.50907 5.9478 2.54743 6.03949C2.58579 6.13118 2.642 6.21434 2.71277 6.28412C2.78355 6.3539 2.86749 6.40892 2.95972 6.44598C3.05194 6.48304 3.15062 6.50141 3.25 6.5H4.31934L5.57813 19.5146C5.71367 20.918 6.90589 22 8.31543 22H15.6836C17.0932 22 18.2854 20.9181 18.4209 19.5146L19.6807 6.5H20.75C20.8494 6.50141 20.9481 6.48304 21.0403 6.44598C21.1325 6.40892 21.2164 6.3539 21.2872 6.28412C21.358 6.21434 21.4142 6.13118 21.4526 6.03949C21.4909 5.9478 21.5107 5.84939 21.5107 5.75C21.5107 5.65061 21.4909 5.5522 21.4526 5.46051C21.4142 5.36882 21.358 5.28566 21.2872 5.21588C21.2164 5.1461 21.1325 5.09108 21.0403 5.05402C20.9481 5.01696 20.8494 4.99859 20.75 5H19.1221C19.0425 4.98709 18.9614 4.98709 18.8818 5H15.46C15.2148 3.31072 13.7542 2 12 2ZM12 3.5C12.9396 3.5 13.7104 4.13408 13.9307 5H10.0693C10.2896 4.13408 11.0604 3.5 12 3.5ZM5.8252 6.5H18.1738L16.9277 19.3701C16.8652 20.0177 16.334 20.5 15.6836 20.5H8.31543C7.66597 20.5 7.13375 20.0168 7.07129 19.3701L5.8252 6.5ZM10.2383 8.98926C10.0395 8.99236 9.85016 9.07423 9.71173 9.21686C9.5733 9.3595 9.49715 9.55125 9.5 9.75V17.25C9.4986 17.3494 9.51696 17.4481 9.55402 17.5403C9.59108 17.6325 9.6461 17.7164 9.71588 17.7872C9.78566 17.858 9.86882 17.9142 9.96051 17.9526C10.0522 17.9909 10.1506 18.0107 10.25 18.0107C10.3494 18.0107 10.4478 17.9909 10.5395 17.9526C10.6312 17.9142 10.7143 17.858 10.7841 17.7872C10.8539 17.7164 10.9089 17.6325 10.946 17.5403C10.983 17.4481 11.0014 17.3494 11 17.25V9.75C11.0014 9.64962 10.9827 9.54997 10.9449 9.45695C10.9071 9.36394 10.8511 9.27946 10.78 9.20852C10.709 9.13758 10.6245 9.08161 10.5314 9.04395C10.4383 9.00629 10.3387 8.98769 10.2383 8.98926ZM13.7383 8.98926C13.5395 8.99236 13.3502 9.07423 13.2117 9.21686C13.0733 9.3595 12.9972 9.55125 13 9.75V17.25C12.9986 17.3494 13.017 17.4481 13.054 17.5403C13.0911 17.6325 13.1461 17.7164 13.2159 17.7872C13.2857 17.858 13.3688 17.9142 13.4605 17.9526C13.5522 17.9909 13.6506 18.0107 13.75 18.0107C13.8494 18.0107 13.9478 17.9909 14.0395 17.9526C14.1312 17.9142 14.2143 17.858 14.2841 17.7872C14.3539 17.7164 14.4089 17.6325 14.446 17.5403C14.483 17.4481 14.5014 17.3494 14.5 17.25V9.75C14.5014 9.64962 14.4827 9.54997 14.4449 9.45695C14.4071 9.36394 14.3511 9.27946 14.28 9.20852C14.209 9.13758 14.1245 9.08161 14.0314 9.04395C13.9383 9.00629 13.8387 8.98769 13.7383 8.98926Z"
                fill="#F6A02C"
              />
            </svg>

            Odhlásit se
          </button>
          <p
            class="text-brand-orange"
            v-if="registerGroupsCheck && !userAlreadyRegisteredToWorkshop && !maxWorkshopsExceeded && programArticle.capacity > 0"
          >
            V tento čas již máte workshop
          </p>

          <button
            v-else-if="!maxWorkshopsExceeded && !userAlreadyRegisteredToWorkshop && programArticle.capacity > 0"
            @click="registerWorkshop"
            class="
            flex
            hover:opacity-80
            focus:outline-none
            transition-all
            duration-200
            items-center
            text-brand-blue
          "
          >
            <svg
              class="mr-1"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.99182 1.65973C7.85933 1.6618 7.73307 1.71637 7.64079 1.81147C7.5485 1.90656 7.49773 2.03439 7.49963 2.16689V7.50022H2.1663C2.10004 7.49929 2.03426 7.51153 1.97278 7.53623C1.9113 7.56094 1.85533 7.59762 1.80815 7.64414C1.76097 7.69067 1.7235 7.7461 1.69792 7.80723C1.67235 7.86836 1.65918 7.93396 1.65918 8.00022C1.65918 8.06649 1.67235 8.13209 1.69792 8.19322C1.7235 8.25434 1.76097 8.30978 1.80815 8.3563C1.85533 8.40283 1.9113 8.43951 1.97278 8.46421C2.03426 8.48892 2.10004 8.50116 2.1663 8.50022H7.49963V13.8336C7.4987 13.8998 7.51094 13.9656 7.53565 14.0271C7.56035 14.0886 7.59703 14.1445 7.64355 14.1917C7.69008 14.2389 7.74551 14.2764 7.80664 14.3019C7.86777 14.3275 7.93337 14.3407 7.99963 14.3407C8.0659 14.3407 8.1315 14.3275 8.19263 14.3019C8.25376 14.2764 8.30919 14.2389 8.35571 14.1917C8.40224 14.1445 8.43892 14.0886 8.46362 14.0271C8.48833 13.9656 8.50057 13.8998 8.49963 13.8336V8.50022H13.833C13.8992 8.50116 13.965 8.48892 14.0265 8.46421C14.088 8.43951 14.1439 8.40283 14.1911 8.3563C14.2383 8.30978 14.2758 8.25434 14.3013 8.19322C14.3269 8.13209 14.3401 8.06649 14.3401 8.00022C14.3401 7.93396 14.3269 7.86836 14.3013 7.80723C14.2758 7.7461 14.2383 7.69067 14.1911 7.64414C14.1439 7.59762 14.088 7.56094 14.0265 7.53623C13.965 7.51153 13.8992 7.49929 13.833 7.50022H8.49963V2.16689C8.50059 2.09997 8.48811 2.03353 8.46292 1.97153C8.43773 1.90952 8.40035 1.8532 8.353 1.8059C8.30564 1.75861 8.24927 1.7213 8.18723 1.69619C8.12519 1.67108 8.05874 1.65868 7.99182 1.65973Z"
                fill="#2699C6"
              />
            </svg>
            Zapsat se na workshop
          </button>
        </div>

        <div class="col-span-4">
          <p
            v-if="programArticle.capacity !== undefined"
            class="justify-self-end"
            :class="{
            'text-brand-orange': programArticle.capacity <= 0,
            'text-brand-green': programArticle.capacity > 0,
          }"
          >
            volných míst: {{ Math.max(0, programArticle.capacity) }}
          </p>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {format} from "date-fns";
import RadioButton from "../Atomic/Radio.vue";
import axios from "axios";

export default {
  emits: [
    "clicked",
    "update:timeslotSelections",
    "unRegisterWorkshop",
    "registerWorkshop",
  ],

  components: {
    RadioButton,
  },

  props: {
    programArticle: {
      type: Object,
    },

    enableMoreInfo: {
      type: Boolean,
      default: true,
    },

    isWorkshop: {
      type: Boolean,
      default: false,
    },

    userLoggedIn: {
      type: Boolean,
      default: false,
    },

    workshopRegistrationState: {
      type: Object,
      default: undefined,
    },

    maxWorkshopRegistrationsPerUser: {
      type: Number,
      default: undefined,
    },

    registerGroupsCheck: {
      type: Boolean,
      default: false,
    },

    timeslotSelections: {
      type: Object,
      default: undefined,
    },

    hasHappeningSiblingUp: {
      type: Boolean,
      default: false,
    },

    hasHappeningSiblingDown: {
      type: Boolean,
      default: false,
    },

    workshopRegistrationOpened: {
      type: Boolean,
      default: false,
    },

    programVotingOpened: {
      type: Boolean,
      default: false
    },
    textTruncateChars: {
      type: Number,
      default: 126
    },
    compact: {
      type: Boolean,
      default: false
    },
    highlightColor: {
      type: String,
      default: 'orange'
    }
  },

  methods: {
    action() {
      this.$emit("clicked", {
        ...this.programArticle,
        time: this.talkTime(),
        userAssignedToWorkshop: this.userAlreadyRegisteredToWorkshop,
      });
    },

    talkTime() {
      if (this.programArticle.start === undefined) {
        return "Čas přednášky";
      }

      return this.programArticle.start + "–" + this.programArticle.end;
    },

    registerWorkshop() {
      this.$emit("registerWorkshop", this.programArticle.id);
    },

    unRegisterWorkshop() {
      this.$emit("unRegisterWorkshop", this.programArticle.id);
    },

    async removeTimeSlot() {
      if (this.selected === this.programArticle.hall) {
        const res = await axios.delete(
          `/api/timeslot/${this.programArticle.timeslot.index}`
        );
        this.$emit("update:timeslotSelections", res.data);
      }
    },
  },

  computed: {
    truncatedDescription() {
      let text = this.programArticle.annotation;

      if (text.length && text.length > this.textTruncateChars) {
        text = text.substring(0, this.textTruncateChars);
        text += "...";
      }

      return text;
    },

    selected: {
      get() {
        if (!this.programVotingOpened) return "";

        if (
          this.timeslotSelections === undefined ||
          this.timeslotSelections.timeslots === undefined
        ) {
          return "";
        }

        if (
          this.timeslotSelections.timeslots[
            this.programArticle.timeslot.index
            ] === null
        ) {
          return "";
        }

        return this.timeslotSelections.timeslots[
          this.programArticle.timeslot.index
          ] === 0
          ? "heureka"
          : "purple";
      },

      async set() {
        const hallAsString = this.programArticle.hall === "heureka" ? 0 : 1;

        const res = await axios.post(
          `/api/timeslot/${this.programArticle.timeslot.index}/${hallAsString}`
        );

        this.$emit("update:timeslotSelections", res.data);
      },
    },

    hasTextOverflow() {
      return this.programArticle.annotation.length > this.textTruncateChars;
    },

    maxWorkshopsExceeded() {
      if (this.workshopRegistrationState !== undefined) {
        if (
          this.workshopRegistrationState.user_registrations.length >=
          this.maxWorkshopRegistrationsPerUser
        ) {
          return true;
        }
      }

      return false;
    },

    userAlreadyRegisteredToWorkshop() {
      if (this.workshopRegistrationState !== undefined) {
        const el = this.workshopRegistrationState.user_registrations.find(
          (e) => e === this.programArticle.id
        );
        if (el) {
          return true;
        }
      }

      return false;
    },
  },
};
</script>

<style>
</style>
